import { type ObjectValuesUnionType } from '../../utils/typing';

export const QRActionTypes = Object.freeze({
  REQUIRE_QR_SCAN: 'QR:REQUIRE_QR_SCAN',
  SET_QR_SCAN_RESULT: 'QR:SET_QR_SCAN_RESULT',
  RESET_QR_SCAN_RESULT: 'QR:RESET_QR_SCAN_RESULT',
  WRONG_QR_SCAN: 'QR:WRONG_SCAN',
});

export type QRActionType = ObjectValuesUnionType<typeof QRActionTypes>;
